import * as React from "react";
const SvgFiRrHandSparkles = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-hand-sparkles_svg__a)">
      <path
        fill="#062147"
        d="M24 6v9a1 1 0 1 1-2 0V6a1 1 0 0 0-.353-.762 1.01 1.01 0 0 0-.823-.224c-.462.075-.824.555-.824 1.093V10a1 1 0 1 1-2 0V4a1.001 1.001 0 0 0-2 0v6a1 1 0 1 1-2 0V3a1.001 1.001 0 0 0-2 0v7a1 1 0 0 1-2 0V5.107c0-.537-.362-1.017-.825-1.093a1 1 0 0 0-.823.224A1 1 0 0 0 8 5v11a1 1 0 0 1-1.683.731L3.68 14.269a1 1 0 1 0-1.363 1.464l4.467 4.307A6.97 6.97 0 0 0 11.641 22h3.357a1 1 0 1 1 0 2h-3.357a8.96 8.96 0 0 1-6.247-2.521L.94 17.182C-.257 16.061-.319 14.158.81 12.951a3 3 0 0 1 4.236-.143l.955.891V5c0-.881.385-1.714 1.057-2.286a3.01 3.01 0 0 1 2.44-.674q.317.052.608.173A3.005 3.005 0 0 1 13.001 0a3 3 0 0 1 2.528 1.388A3 3 0 0 1 17.001 1c1.382 0 2.548.939 2.894 2.213q.291-.12.61-.172a3.01 3.01 0 0 1 2.438.674A3 3 0 0 1 24 6m-7.472 9.303-1.308-.523-.523-1.308a.75.75 0 0 0-1.394 0l-.52 1.301-1.299.492a.748.748 0 0 0-.025 1.392l1.318.556.526 1.316a.75.75 0 0 0 1.394 0l.523-1.308 1.308-.523a.75.75 0 0 0 0-1.395m6.921 4.384-1.526-.611-.61-1.526a.876.876 0 0 0-1.627 0l-.607 1.518-1.515.574a.874.874 0 0 0-.03 1.624l1.538.648.614 1.536a.876.876 0 0 0 1.626 0l.611-1.527 1.526-.61a.876.876 0 0 0 0-1.626M.382 7.047l1.1.463.437 1.097a.626.626 0 0 0 1.16 0l.436-1.09 1.09-.436a.626.626 0 0 0 0-1.16l-1.09-.436-.436-1.09a.626.626 0 0 0-1.16 0l-.433 1.084-1.082.41a.624.624 0 0 0-.022 1.158"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-hand-sparkles_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHandSparkles;
